module.exports = __webpack_public_path__ + "img/4.495ef68c.png";